import React,{useState,useEffect} from 'react'
import $ from 'jquery'

const Dropdown2 = (props) => {
    const [show,setShow] = useState(false)
    const [myvariable,setmyvariable] = useState(props.myplaceholder?props.myplaceholder:"Select")
    const [searchQuery, setSearchQuery] = useState('');

    const filteredOptions = props.options && props.options.filter((option) =>
    JSON.stringify(option.opt).toLowerCase().includes(searchQuery.toLowerCase())
  );
const toggleDropdown = () => {
    setShow(true);
  };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

    const handleDrp2=()=>{
        console.log("click hoise")
        setShow(!show)
        $('.overlayfordrpdwn').css('display','block');
        $('.overlayfordrpdwn').click(function(){
            setShow(false)
            $('.overlayfordrpdwn').css('display','none');
        })
    }
    const handlevariable=(e,myid)=>{
        setmyvariable(e.target.innerHTML)
        if(props.func){

            props.func(e.target.innerHTML,myid)
        }
        
        setShow(false)
        setSearchQuery("")
        $('.overlayfordrpdwn').css('display','none');
    
        
    }
    useEffect(() => {
      
            setmyvariable(props.myplaceholder);
            
      }, [props.myplaceholder]);
    const handleoverlayhide=()=>{
        // setShow(false)
        $('.overlayfordrpdwn').css('display','none');
    }
    useEffect(()=>{
        setmyvariable(props.myplaceholder)
    },[props.myplaceholder])
  return (
    <>
    <div className="wrapperwrap">
    
    <div className="Dropdown2" style={props.err=="err"?{border:"1px solid #ED1C24"}:{}} onClick={handleDrp2}>
        <p style={myvariable=="Active"?{color:"#00CA55",fontWeight:"700",paddingLeft:"10px",fontSize:`${props.fontsize}`,fontFamily:`${props.fontfamily}`}:myvariable=="Inactive"?{color:"#FF5454",fontWeight:"700",paddingLeft:"10px",fontSize:`${props.fontsize}`,fontFamily:`${props.fontfamily}`}:{paddingLeft:"10px",lineHeight:"35px",fontSize:`${props.fontsize}`,fontFamily:`${props.fontfamily}`}}>{myvariable}</p>
        <img src="./assets/images/icons/drpdwnicon.png" alt="drpdwnicon" />
    </div>
        <ul onClick={handleoverlayhide} className={show==true?"Dropdown2-menu showme":"Dropdown2-menu"}>
            <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchInputChange}
            onClick={toggleDropdown}
            style={{
                fontSize:`${props.fontsize}`,
                width:"100%",
                paddingLeft:"15px"
            }}
            />
            {
                searchQuery?
                filteredOptions.map((item,key)=>{
                    return(
                        <li style={{lineHeight:"35px",fontSize:`${props.fontsize}px`,fontFamily:`${props.fontfamily}`}} key={key} onClick={(e)=>handlevariable(e,item.id)}>{item.opt}</li>
                    )
                })
                :
                props.options.map((item,key)=>{
                    return(
                        <li style={{lineHeight:"35px",fontSize:`${props.fontsize}px`,fontFamily:`${props.fontfamily}`}} key={key} onClick={(e)=>handlevariable(e,item.id)}>{item.opt}</li>
                    )
                })
            }
        </ul>
    </div>
    
    </>
  )
}

export default Dropdown2